module.exports = __webpack_public_path__ + "static/media/tuv.c60ea032.svg";